export default {
    yes: "是的",
    no: "不"
}